import classNames from "classnames";
import { Svg } from "components/base/svg/Svg";
import { FC, ReactNode, SyntheticEvent } from "react";
import styles from "./two-factor.module.sass";

type IProps = {
    value: string;
    iconSrc: string;
    active: boolean;
    label: ReactNode;
    info: string;
    onChange: (val: string) => void;
    checked: boolean;
};

const AuthChannelRadioInput: FC<IProps> = ({
    value,
    active,
    iconSrc,
    label,
    info,
    onChange,
    checked,
}) => {
    const handleChange = (e: SyntheticEvent<HTMLInputElement>) => {
        const value = e.currentTarget.value;
        onChange(value);
    };

    return (
        <label htmlFor={value.toLowerCase()} className={classNames(active && styles.enabled)}>
            <input
                checked={checked}
                type="radio"
                name="authType"
                id={value.toLowerCase()}
                value={value}
                onChange={handleChange}
            />

            <span className={styles.checkmark} />
            <Svg src={iconSrc} className="svg-icon" />
            <span>
                {label}
                <strong>{info}</strong>
            </span>
        </label>
    );
};

export default AuthChannelRadioInput;
